<div class="kng-footer d-flex flex-column  {{state.cssClass}}" *ngIf="isRaymond">
  <div class="ribbon mt-auto" *ngIf="footerdata?.ribbonImage">
    <img src="{{ footerdata.ribbonImage }}" alt="{{ footerdata.altText }}"/>
  </div>
  <footer
    class="flex-shrink-0 footer mt-auto"
    [ngStyle]="{ 'padding-bottom': isActionFooterPresent ? '8.25rem' : '3rem' }"
  >
    <div class="footer-pr">
      <div class="logo" >
        <img
          (keypress) = "navigateTologo()" (click)="navigateTologo()" role="button" tabindex="0"
          src="{{ footercontent.logoImagePath }}"
          alt="{{ footercontent.altText }}"
          aria-label="Raymond iWConnect Logo"
        />
      </div>
      <div class="flex-container d-flex justify-content-between">
        <div
          class="p-2 bd-highlight label"
          *ngFor="let footer of footercontent.footermenu"
        >
          <div class="icon" [ngClass]="{ languageSelection: footer.label === footerLabel.country }">
              <span *ngIf="footer.iconPath?.length" tabindex="0">
                <img
                  src="{{ footer.iconPath }}"
                  alt="{{ footer.altText }}"
                  attr.aria-label="{{ footer?.altText }}"
                  [ngClass]="{ flagImg: footer.label === footerLabel.email }"
              /></span>
              <span *ngIf="!(footer?.label === footerLabel.country && isRaymond)" tabindex="0" class="icon-text"  [ngClass]="{ 'raymond-assembled-in-usa-text': isRaymond && footer?.label === 'Assembled in the USA' }">{{ footer?.label }}</span>
            </div>

          <div class="description" *ngIf="footer.label === footerLabel.phone" tabindex="0">
            <a aria-label="clickable phone" target="_self" class="phoneclick" href="tel:{{footer?.labelValue}}" (click)="handleTelClick($event)">{{ footer?.labelValue }}</a>
          </div>
          <div class="description" *ngIf="footer.label === footerLabel.email && isRaymond" tabindex="0">
            <p class="email" aria-label="clickable email" target="_self">{{ footer?.labelValue }} </p>
          </div>

          <div
            class="description"
            [ngClass]="{ test_states: footer.label === footerLabel.usa}"
            *ngIf="footer.label === footerLabel.usa"
          >
            <a
              class="usa-hyperlink"
              href="{{ footer.url }}"
              target="_blank"
              rel="noopener noreferrer"
              >{{ footer?.labelValue }}</a
            >
          </div>

          <div class="description" *ngIf="footer.label === footerLabel.support">
            <div class="mail" (click)="navigateto(footer.url)">
              {{
                footer.labelValue
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="container text-center copyright-panel">
        <span class="Copyright" tabindex="0"
          > {{ footercontent?.copyright?.label }}</span
        ><span class="linklabel_separator">|</span>
        <button
          class="cta-link"
          *ngFor="let label of footercontent.copyright?.labelUrl; let i = index; let isLastIndex=last"
          (click)="ctaLinkClick(label)"
        >
          <span class="linklabel">{{ label.label }}</span
          ><span
            *ngIf="!isLastIndex"
            class="linklabel_separator"
            >|</span
          >
        </button>
      </div>
    </div>
  </footer>
</div>


<div class="d-flex flex-column kng-footer" *ngIf="!isRaymond">
  <footer id="aem-footer-wrapper">
    <div id="externaHtmlHandler" [innerHTML]="state.footercontent.unifiedFooter | safeHtml"></div>
  </footer>
</div>
